import { cmsModule } from '@utils';

const weAre = cmsModule('we-are');
const productFeatures = cmsModule('product-features');

export default [
	{
		...weAre,
		label: 'Heading',
		fields: weAre.fields.filter(field => {
			return field.name !== 'sectionTitle';
		})
	},
	cmsModule('intro'),
	{
		...productFeatures,
		fields: productFeatures.fields.filter(field => field.name !== 'title')
	},
	cmsModule('carousel-quote'),
	cmsModule('cases-carousel'),
	cmsModule('blog-posts')
];
